import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";

const HEIGHT = 60;

const Base = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${HEIGHT}px;
  background-color: white;
  border-bottom: 1px solid ${select.color(["grey", 1])};
  padding: 0px ${select.space(3)};
`;

const RightWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  left: any;
  right: any;
  children: any;
};

function TopBar({ style, className, left, right, children }: Props, ref: any) {
  return (
    <Base ref={ref} style={style} className={className}>
      {left}
      <RightWrapper>{right}</RightWrapper>
      {children}
    </Base>
  );
}

export default React.forwardRef(TopBar);
